/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
// import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "url-search-params-polyfill";
import Bootstrap from "./Bootstrap";
import Heartbeat from "./utils/Heartbeat";
import SessionTimeoutCheck from "./utils/SessionTimeoutCheck";
import configureStore from "./configureStore";
import config from "./api/config";
// import theme from "./theme";
import "./assets/css/index.less";
import { ThemeProvider, theme } from "@mineral/core";

if (process.env.NODE_ENV == "development") {
  window.OPERATOR_CONSOLE = {
    sid: "Bearer " + "<%=sid%>",
    isSaas: "<%=isSaas%>",
    do_heartbeat: "<%=doHeartbeat%>",
    cspNonce: "<%=nonse%>",
  };
}
const store = configureStore();
const heartbeat = new Heartbeat(store.dispatch);
let do_heartbeat = window.OPERATOR_CONSOLE.do_heartbeat;

if (do_heartbeat !== "true" && do_heartbeat !== "false") {
  do_heartbeat = false;
}
if (do_heartbeat === "true") heartbeat.start(store.dispatch);

const sessionTimeoutCheck = new SessionTimeoutCheck(store.dispatch);
sessionTimeoutCheck.start(store.dispatch);

ReactDOM.render(
  <Provider store={store}>
    <Router basename={config.basename}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Bootstrap />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);
